<template>
  <div v-if="value !== null && value !== undefined && value !== ''" class="dict-text-container">
    <!-- 加载状态 -->
    <span v-if="loading" class="loading-indicator">
      <i class="el-icon-loading" />
    </span>

    <!-- 正常显示状态 -->
    <span v-else class="dict-text" :class="colorMode ? getColorClass() : 'dict-color-disabled'">
      {{ displayText || fallbackText }}
    </span>
  </div>
</template>

<script>

export default {
  name: "DictText",
  props: {
    dictType: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: ''
    },
    // 未匹配时的回退文本
    fallbackText: {
      type: String,
      default: '—'
    },
    // 是否启用颜色模式（根据字典值自动改变颜色）
    colorMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      displayText: ''
    }
  },
  watch: {
    dictType: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadDictValue();
        }
      }
    },
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadDictValue();
        }
      }
    }
  },
  methods: {
    // 获取颜色样式类名
    getColorClass() {
      if (!this.colorMode) {
        return '';
      }

      // 将value转换为数字，如果转换失败则返回空字符串
      const numValue = parseInt(this.value);
      if (isNaN(numValue)) {
        return '';
      }

      // 根据数值返回对应的颜色类名
      return `dict-color-${numValue}`;
    },

    // 加载字典数据
    async loadDictValue() {
      // 先检查是否已有数据
      const dictValue = this.$store.getters["dict/getLabel"](this.dictType, this.value);
      if (dictValue) {
        this.displayText = dictValue;
        return;
      }

      // 避免重复请求
      // 如果发现字典已在请求中，使用 $store.watch 等待数据加载完成
      // 否则触发新的请求
      if (this.$store.state.dict.pendingDicts.has(this.dictType)) {
        await new Promise(resolve => {
          const unwatch = this.$store.watch(
              state => state.dict.dictionaries[this.dictType],
              () => {
                unwatch();
                resolve();
              }
          );
        });
      } else {
        await this.$store.dispatch("dict/fetchDictData", {
          dictType: this.dictType
        });
      }

      this.displayText = this.$store.getters["dict/getLabel"](
          this.dictType,
          this.value
      );
      // const dictValue = this.$store.getters["dict/getLabel"](this.dictType, this.value);
      // if (dictValue) {
      //   this.displayText = dictValue;
      //   return
      // }
      // await this.$store.dispatch("dict/fetchDictData", { dictType: this.dictType }).then(() => {
      //   this.displayText = this.$store.getters["dict/getLabel"](this.dictType, this.value);
      // })

    }
  }
}
</script>

<style scoped>
.dict-text-container {
  display: inline-block;
  /* min-width: 80px; */
}

.loading-indicator {
  color: #999;
  font-size: 14px;
}

.dict-text {
  display: inline-block;
  padding: 0 10px;
  color: #303133;
  font-size: 14px;
  transition: all 0.3s;
  margin-left: 5px;
}

.dict-text.dict-color-disabled {
  background-color: transparent;
  color: #303133;
  padding: 0;
}

/* 颜色模式样式 */
.dict-text.dict-color-0 {
  background-color: #f45866; /* 红色 */
  color: #ffffff;
}

.dict-text.dict-color-1 {
  background-color: #44a9f3; /* 蓝色 */
  color: #ffffff;
}

.dict-text.dict-color-2 {
  background-color: #fab334; /* 黄色 */
  color: #ffffff;
}

.dict-text.dict-color-3 {
  background-color: #67c23a; /* 绿色 */
  color: #ffffff;
}

.dict-text.dict-color-4 {
  background-color: #e6a23c; /* 橙色 */
  color: #ffffff;
}

.dict-text.dict-color-5 {
  background-color: #909399; /* 灰色 */
  color: #ffffff;
}

.dict-text.dict-color-6 {
  background-color: #f56c6c; /* 浅红色 */
  color: #ffffff;
}

.dict-text.dict-color-7 {
  background-color: #409eff; /* 深蓝色 */
  color: #ffffff;
}

.dict-text.dict-color-8 {
  background-color: #9c27b0; /* 紫色 */
  color: #ffffff;
}

.dict-text.dict-color-9 {
  background-color: #ff9800; /* 深橙色 */
  color: #ffffff;
}
</style>
